/* tslint:disable */
/* eslint-disable */
/**
 * residents
 * residents
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SearchDoctorsResponse } from './SearchDoctorsResponse';
import {
    SearchDoctorsResponseFromJSON,
    SearchDoctorsResponseFromJSONTyped,
    SearchDoctorsResponseToJSON,
} from './SearchDoctorsResponse';

/**
 * 
 * @export
 * @interface SearchDoctors200Response
 */
export interface SearchDoctors200Response {
    /**
     * 
     * @type {SearchDoctorsResponse}
     * @memberof SearchDoctors200Response
     */
    data?: SearchDoctorsResponse;
}

/**
 * Check if a given object implements the SearchDoctors200Response interface.
 */
export function instanceOfSearchDoctors200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SearchDoctors200ResponseFromJSON(json: any): SearchDoctors200Response {
    return SearchDoctors200ResponseFromJSONTyped(json, false);
}

export function SearchDoctors200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchDoctors200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : SearchDoctorsResponseFromJSON(json['data']),
    };
}

export function SearchDoctors200ResponseToJSON(value?: SearchDoctors200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': SearchDoctorsResponseToJSON(value.data),
    };
}

